import axios from '../axios'

// モジュール作成
const postModuleApi = async (courseId, payload) => {
  return await axios.post(`api/lms/courses/${courseId}/modules`, payload)
}

export default postModuleApi
